import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { CONSTANTS, EVENT_EMITTERS, OPTIONS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-dropdown',
	styleUrls: ['./dropdown.component.css'],
	templateUrl: './dropdown.component.html'
})
export class DropdownComponent implements OnInit {
	dropdownList = [];
	selectedItems = [];
	dropdownSettings: any = {};
	content = '';
	checkForAdvertisers: any;

	public type: any;
	selections = [];

	debouncer: Subject<any> = new Subject();

	constructor(private analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.dropdownSettings = {
			AdvertisersDropDown: true,
			badgeShowLimit: 1,
			disabled: false,
			enableCheckAll: true,
			enableSearchFilter: true,
			selectAllText: 'Select All',
			singleSelection: false,
			text: 'Select Advertisers',
			unSelectAllText: 'Uncheck All'
		};
		this.debouncer.pipe(debounceTime(1000)).subscribe((val) => {
			if (this.type === CONSTANTS.ADVERTISERS) {
				EmitterService.get(EVENT_EMITTERS.ADVERTISERS).emit(this.selectedItems);
			} else if (this.type === CONSTANTS.CAMPAIGNS) {
				EmitterService.get(EVENT_EMITTERS.CAMPAIGNS).emit(this.selectedItems);
			}
		});
		if (this.type === CONSTANTS.CAMPAIGNS) {
			EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).subscribe((response: any) => {
				if (response) {
					this.getConfigurationByType();
				}
			});
		}

		this.getConfigurationByType();
	}

	onItemSelect(item: any): void {
		this.debouncer.next(this.type);
	}

	OnItemDeSelect(item: any): void {
		this.debouncer.next(this.type);
	}

	onSelectAll(items: any): void {
		this.selections = items;
		this.debouncer.next(this.type);
	}

	onDeSelectAll(items: any): void {
		this.selections = items;
		this.debouncer.next(this.type);
	}

	getConfigurationByType(): void {
		if (this.type === CONSTANTS.ADVERTISERS) {
			this.dropdownList = this.analyticsDataModel.advertisersListForDropDown;
			this.selectedItems = this.analyticsDataModel.selectedAdvertisersListForDropDown;
			this.dropdownSettings.text = 'Select Advertisers';
			this.dropdownSettings.searchPlaceholderText = 'Search';
			this.dropdownSettings.AdvertisersDropDown = true;
			if (this.selectedItems.length > 0) {
				this.selections = this.analyticsDataModel.selectedAdvertisersListForDropDown;
				this.debouncer.next(this.type);
			}
			this.content = `Please select up to ${OPTIONS.ADVERTISERS.DEFAULT_SELECTION} Advertisers`;
			this.checkForAdvertisers = true;
		} else if (this.type === CONSTANTS.CAMPAIGNS) {
			this.dropdownSettings.text = 'Select Campaigns';
			this.dropdownSettings.AdvertisersDropDown = false;
			this.dropdownSettings.searchPlaceholderText = 'Search';
			this.dropdownList = this.analyticsDataModel.campaignsListForDropDown;
			this.selectedItems = this.analyticsDataModel.selectedCampaignsListForDropDown;
			if (this.selectedItems.length > 0) {
				this.debouncer.next(this.type);
			}
			if (this.dropdownList.length > 0) {
				this.content = 'Select all campaigns';
			}
			if (this.dropdownList.length === 0) {
				this.content = '';
			}
			this.checkForAdvertisers = false;
		}
	}
}
